'use client';
import { MouseEvent, useEffect } from 'react';
import { FooterLanguages, useBreakpoint } from 'components/pcc-components';
import {
  useParams,
  usePathname,
  useSearchParams,
  useRouter
} from 'next/navigation';
import { preventDefaultLinkEvent } from '@cat-ecom/common/utils/DOMUtils';
import { Language as PCCLanguage } from '@cat-ecom/pcc-components/src/components/footer/footer-languages/FooterLanguages';
import { useHash } from 'hooks/use-url-hash';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { WC_GUEST_SESSION } from 'constants/storageConstants';
import { getCookie, setCookie } from 'utils/cookieUtils';

export const LanguageClientLinks = ({
  langId,
  languages,
  isMobileFooterDesignupdate,
  isLoggedIn = false
}: {
  languages: PCCLanguage[] | Language[];
  langId: string;
  isMobileFooterDesignupdate: boolean;
  isLoggedIn?: boolean
}) => {
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');.
  const { lang }: esiteParams = useParams();
  /*
    TODO - Input Validations - usePathName: string except the
    generalRestrictedCharacters (@\constants\securityConstants.ts)
  */
  const pathname = usePathname();

  /*  TODO - Input Validations - useSearchParams: The search param object should contain key value pairs where
  the value is of string type, not including reservered url special / unsafe characters like / \ & ? = : % + ' " ; < > { } [ ] @ #
  */
  const search = useSearchParams().toString();
  const router = useRouter();
  const hash = useHash();
  const isMd = useBreakpoint(PAGE_BREAKPOINTS.MD);

  const hashString = hash ? `#${hash}` : '';
  const searchString = search ? `?${search}` : '';
  const languageHref = ({ seoToken }) =>
    `${pathname.replace(lang, seoToken)}${searchString}${hashString}`;

  const languageLinksMap = languages.map((language) => ({
    ...language,
    localeName: language.locale,
    nativeDescriptionString: language.nativeDescription,
    href: languageHref(language)
  }));

  const onClickHandler = (event: MouseEvent, language: PCCLanguage) => {
    if (preventDefaultLinkEvent(event)) {
      router.push(language.href);
    }
  };

  useEffect(() => {
    const wcSessionValue = getCookie(WC_GUEST_SESSION)?.split('_') ?? [];
    if (!isLoggedIn && wcSessionValue.length && wcSessionValue[3] !== lang) {
      wcSessionValue[3] = lang;
      wcSessionValue[5] = langId;
      setCookie(WC_GUEST_SESSION, wcSessionValue.join('_'));
    }
  }, [lang, langId, isLoggedIn]);

  return (
    <FooterLanguages
      langId={langId}
      isMobile={!isMd}
      isMobileFooterDesignUpdate={isMobileFooterDesignupdate}
      languages={languageLinksMap}
      onClick={onClickHandler}
    />
  );
};
